import React, { useState } from "react";
import "./Nabar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  // 👉 MẢNG MENU ĐẦY ĐỦ CẢ TÊN + LINK
  const menuItems = [
    { label: "DỊCH VỤ MÁY LẠNH", href: "/maylanh" },
    { label: "DỊCH VỤ TỦ LẠNH", href: "/tulanh" },
    { label: "SỬA MÁY GIẶT", href: "/maygiat" },
    { label: "SỬA TIVI", href: "/tivi" },
    { label: "Chính sách bảo mật", href: "/privacy" },
  ];

  return (
    <header className="dl-header">

      {/* 🔴 Thanh top đỏ */}
      <div className="dl-topbar">
        <div className="dl-container dl-topbar-inner">
          <span className="dl-topbar-text">
            DỊCH VỤ BẢO HÀNH ĐIỆN LẠNH 24/7 - GỌI ĐẾN NGAY
          </span>

          
        </div>
      </div>

      {/* 🟦 Navbar chính */}
      <nav className="dl-navbar m-2">
        <div className="dl-container dl-navbar-inner">

          {/* ☰ Nút Mobile */}
          <button
            className="dl-nav-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>

          {/* Logo */}
          <div>
            <img style={{width:'80px',height:'auto'}} src="/logodaorut.png" alt="so1" />
          </div>

          {/* Icon mail mobile */}
         

          {/* Khu vực phải desktop */}
          <div className="dl-nav-right">

            {/* Menu desktop */}
            <ul className="dl-menu">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Menu mobile xổ xuống */}
        <div className={`dl-mobile-menu ${open ? "open" : ""}`}>
          <ul>
            {menuItems.map((item, index) => (
              <li key={index}>
                <a href={item.href} onClick={() => setOpen(false)}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

      </nav>
    </header>
  );
}
